<template>
  <b-container fluid>
    <b-row>
      <b-col md="3">
        <!-- <iq-card class="calender-small">
          <template v-slot:body>
            <flat-pickr :config="config" value="" class="d-none"/>
          </template>
        </iq-card> -->
        <iq-card v-if="viewClassificationComp">
          <template v-slot:headerTitle>
            <h4 class="card-title ">Classification</h4>
          </template>
          <template v-slot:body>
            <ul class="m-0 p-0 job-classification" style="height: 200px; overflow-y: scroll;">
              <li class="" v-for="(d, i) in classificationList" :key="`classification-${i}`"><a href="#" @click="triggerClassificationModal('Edit', d)"><i class="ri-check-line mr-2" :style="`background-color: ${d.color}`" />{{ d?.name }}</a> <i class="las la-trash float-right" @click="deleteClassificationData(d?.id)" style="color:red; font-size: 20px; cursor:pointer;"></i></li>
            </ul>
          </template>
        </iq-card>
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">Today's Schedule</h4>
          </template>
          <template v-slot:body>
            <ul class="m-0 p-0 today-schedule" style="height: 200px; overflow-y: scroll;">
              <li class="d-flex" v-for="(d, i) in todayScheduleList" :key="`today-sched-${i}`" style="cursor:pointer" @click="openAppointmentInfo(d)">
                <div class="schedule-icon"><i class="ri-checkbox-blank-circle-fill text-primary" :style="`color: ${d?.color}`" /></div>
                <div class="schedule-text"> <span>{{ d?.isRequiredPatient === 'Y' ? d?.patient_name : d?.title }} <br> <small>{{ d?.note }}</small></span>
                  <span>{{  `${d?.time_start} to ${d?.time_end}`  }}</span></div>
              </li>
            </ul>
          </template>
        </iq-card>
      </b-col>
      <b-col md="9">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">Book Appointment</h4>
          </template>
          <template v-slot:headerAction>
            <a href="#" class="btn btn-primary" @click="triggerBookingModal('Add', {})"><i class="ri-add-line mr-2"></i>Book Appointment</a>
          </template>
          <template v-slot:body>
            <FullCalendar :calendarEvents="bookingList" @getEventClickId="getEventClickId($event)" @viewMonthYearChanged="onViewMonthYearChanged"/>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <classificationModal @triggerClassification="triggerClassification" :modalFormAction="modalFormAction" :selectedItem="selectedItem"/>
    <PatientListModal
      :patient-details="patientDetailsForm"
      @selectPatient="openBookingAppointmentModal"
      @selectNonExistingPatient="openBookingAppointmentModalForNonExistingPatient"
    />
    <BookingAppointmentModal
      ref="bookingModal"
      :patient="selectedPatient"
      :nonExistingPatient="selectedNonExistingPatient"
      :classification-list="classificationList"
      modal-form-action="Create"
      @triggerBooking="triggerBooking"
    />
    <b-modal id="modal-booking-info" ref="modal-booking-info" title="Appointment Info">
      <div class="row">
        <div class="col-12">
          <ul class="list-unstyled">
            <li><b>Classification: </b>{{ selectedItem?.classification_name }}</li>
            <li><b>Title: </b>{{ selectedItem?.title }}</li>
            <li><b>Note: </b>{{ selectedItem?.note }}</li>
            <li><b>Date/Time Start: </b>{{ selectedItem?.dateStart }}</li>
            <li><b>Date/Time end: </b>{{ selectedItem?.dateEnd }}</li>
            <li v-if="selectedItem?.isRequiredPatient === 'Y'"><b>Patient: </b>{{ selectedItem?.patient_name }} [{{selectedItem?.patient_no}}]</li>
            <li v-if="selectedItem?.isRequiredPatient === 'Y'"><b>Contact No: </b>{{ selectedItem?.contact_no }}</li>
          </ul>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="secondary" @click="$bvModal.hide('modal-booking-info')">Close</b-button>
        <b-button variant="primary" @click="openUpdateBookingModal(selectedItem)">Update</b-button>
        <b-button variant="danger" @click="cancelBooking(selectedItem)">Delete Booking</b-button>
      </template>
    </b-modal>
  </b-container>
</template>
<script>
import { xray } from '../../../config/pluginInit'
import classificationModal from './CalendarComponents/ClassificationModal.vue'
import PatientListModal from './CalendarComponents/PatientListModal.vue'
import BookingAppointmentModal from './CalendarComponents/BookingAppointmentModal.vue'
import classification from '../../../services/classification'
import booking from '../../../services/booking'
import _ from 'lodash'
import { mapGetters } from 'vuex'
export default {
  name: 'CustomerServiceCalendar',
  components: { classificationModal, PatientListModal, BookingAppointmentModal },
  data () {
    return {
      modalFormAction: 'Add',
      config: {
        dateFormat: 'Y-m-d',
        inline: true
      },
      viewClassificationComp: false,
      classificationList: [],
      bookingList: [],
      todayScheduleList: [],
      selectedItem: {},
      patientDetailsForm: {
        patientNo: '',
        firstName: '',
        lastName: '',
        birthDate: '',
        contactNumber: ''
      },
      selectedPatient: null,
      selectedNonExistingPatient: null,
      selectedMonth: null,
      selectedYear: null
    }
  },
  computed: {
    ...mapGetters({
      userDetails: 'Auth/userDetails'
    })
  },
  watch: {
    userDetails: _.debounce(function () {
      this.checkAccessOnClassification()
    })
  },
  mounted () {
    xray.index()
    this.triggerClassification()
    this.getAllTodayBookings()

    // initial calendar load - fetch bookings for current month
    const today = new Date()
    const month = today.getMonth() + 1
    const year = today.getFullYear()

    this.triggerBooking(month, year)
    // this.getAllTodaysBooking()
    this.checkAccessOnClassification()
  },
  methods: {
    checkAccessOnClassification () {
      if (this.userDetails?.role) {
       this.viewClassificationComp = (['AD', 'SA']).includes(this.userDetails.role)
      }
    },
    getEventClickId (evt) {
      booking.getBookingDetails(evt)
      .then(({ data }) => {
        if (data.success) {
          this.openAppointmentInfo(data?.data)
        }
      })
      .catch((error) => { console.log(error) })
    },
    openAppointmentInfo (data) {
      this.selectedItem = data
      this.$bvModal.show('modal-booking-info')
    },
    deleteClassificationData (id) {
      classification.deleteClassification(id)
      .then(({ data }) => {
        if (data?.success) {
          this.triggerClassification()
        }
        this.$swal(data?.message)
       })
    },
    getTodaysAppointment () {},
    triggerBookingModal (action = 'Add', item = {}) {
      this.selectedItem = item
      this.modalFormAction = action
      // this.$bvModal.show('modal-booking')
      this.$swal.fire({
          title: 'Patient Details',
          html: `
            <input type="text" id="patientNo" class="swal2-input full-width-input" placeholder="Patient No">
            <div style="text-align: center; margin: 10px 0; font-weight: bold; color: #555;">--- OR ---</div>
            <input type="text" id="firstName" class="swal2-input full-width-input" placeholder="First Name">
            <input type="text" id="lastName" class="swal2-input full-width-input" placeholder="Last Name">
            <input type="date" id="birthDate" class="swal2-input full-width-input" placeholder="Birth Date">
            <input type="tel" id="contactNumber" class="swal2-input full-width-input" placeholder="Contact Number">
          `,
          focusConfirm: false,
          customClass: {
            popup: 'swal2-custom-width',
            actions: 'swal2-actions-gap'
          },
          showCancelButton: true,
          preConfirm: () => {
            const patientNo = this.$swal.getPopup().querySelector('#patientNo').value.trim()
            const firstName = this.$swal.getPopup().querySelector('#firstName').value.trim()
            const lastName = this.$swal.getPopup().querySelector('#lastName').value.trim()
            const birthDate = this.$swal.getPopup().querySelector('#birthDate').value.trim()
            const contactNumber = this.$swal.getPopup().querySelector('#contactNumber').value.trim()

            // Conditional validation

            // Validation logic
            if (!patientNo && !firstName && !lastName && !birthDate && !contactNumber) {
              this.$swal.showValidationMessage('Please fill at least Patient No or all required fields')
              return false
            }

            if (!patientNo) {
              if (!firstName || !lastName || !birthDate || !contactNumber) {
                this.$swal.showValidationMessage(`Please fill out all fields if Patient No is empty`)
                return false
              }
            }

            return { patientNo, firstName, lastName, birthDate, contactNumber }
          }
      }).then((result) => {
        if (result.isConfirmed) {
          this.patientDetailsForm = result.value
          this.$bvModal.show('modal-patient-list')
        }
      })
    },
    triggerClassificationModal (action = 'Add', item = {}) {
      this.selectedItem = item
      this.modalFormAction = action
      this.$bvModal.show('modal-classification')
    },
    triggerClassification () {
      classification.getAllClassifications()
      .then(({ data }) => {
        if (data?.success) {
          this.classificationList = data.data
        }
      })
      .catch(error => { console.log(error) })

      this.selectedItem = {}
    },
    triggerBooking (month = null, year = null) {
      // Determine default month/year if not provided
      if (!month || !year) {
        const today = new Date()
        month = today.getMonth() + 1
        year = today.getFullYear()
      }

      booking.getBookingsByMonthYear(month, year)
        .then(({ data }) => {
          if (data?.success) {
            // Update calendar events
            this.bookingList = data.data.map(d => ({
              id: d?.id,
              title: `${d?.classification_name} ( ${d?.isRequiredPatient === 'Y' ? d?.patient_name : d?.title} )`,
              start: d?.date_from,
              end: d?.date_to,
              color: d?.color
            }))
          } else {
            this.bookingList = []
            this.todayScheduleList = []
          }
        })
        .catch(error => {
          console.error('Error fetching bookings by month/year:', error)
        })

      this.selectedItem = {}
    },
    onViewMonthYearChanged ({ month, year }) {
      this.selectedMonth = month
      this.selectedYear = year
      this.triggerBooking(month, year)
    },
    getAllTodayBookings () {
      booking.getAllTodaysBooking()
        .then(({ data }) => {
          if (data?.success) {
            this.todayScheduleList = data.data
          }
        })
        .catch(error => { console.log(error) })
    },
    openBookingAppointmentModal (patientData) {
      this.selectedPatient = patientData
      this.$bvModal.show('modal-booking-appointment')

      // force trigger the setter inside the modal
      this.$nextTick(() => {
        this.$refs.bookingModal.setPatient(patientData)
      })
    },
    openBookingAppointmentModalForNonExistingPatient (patientData) {
      patientData.patient_no = ''
      this.selectedNonExistingPatient = patientData
      this.$bvModal.show('modal-booking-appointment')

      // force trigger the setter inside the modal
      this.$nextTick(() => {
        this.$refs.bookingModal.setNonExistingPatient(patientData)
      })
    },
    cancelBooking () {
      this.$swal.fire({
          title: 'Are you sure you want to remove this booking?',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No'
      }).then((result) => {
        if (result.isConfirmed) {
          booking.deleteBooking(this.selectedItem.id)
          .then(response => {
            if (response.data.success) {
              let month = this.selectedMonth
              let year = this.selectedYear

              if (this.selectedYear === null && this.selectedYear === null) {
                const today = new Date()
                month = today.getMonth() + 1
                year = today.getFullYear()
              }
              this.triggerBooking(month, year)
              this.$bvModal.hide('modal-booking-info')
            }
            this.$swal(response?.data?.message)
          })
        }
      })
    },
    openUpdateBookingModal (booking) {
      // Set the selected patient if exists
      if (booking.id) {
        this.selectedPatient = {
          id: booking.id,
          first_name: booking.first_name,
          last_name: booking.last_name,
          patient_no: booking.patient_no,
          patient_id: booking.patient_id
        }
      } else {
        this.selectedPatient = null
      }

      // Prefill the booking form data
      this.$nextTick(() => {
        const modal = this.$refs.bookingModal
        modal.modalFormAction = 'Update' // change title
        modal.formData = {
          id: booking.id,
          classification_id: 1,
          patient_id: booking.patient_id,
          title: booking.title,
          note: booking.note,
          date_from: booking.date_from,
          date_to: booking.date_to
        }

        // Prefill patient info display
        if (this.selectedPatient) modal.setPatient(this.selectedPatient)

        this.$bvModal.hide('modal-booking-info')
        this.$bvModal.show('modal-booking-appointment')
      })
    }
  }
}
</script>
